// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles extracted from manager.js */

.obj {
  margin: 0.2em;
  border: none;
  padding: 0;
  vertical-align: top;
}

.pred, .pred.internal {
  /* Add any specific styles for predicate TDs here */
}

.iconTD {
  margin: 0.2em;
  border: none;
  padding: 0;
  vertical-align: top;
  width: 0px;
}

.labelTD {
  width: 100%;
}

.paneIconTray {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.paneShown {
  width: 24px;
  border: none !important;
  border-radius: var(--border-radius-md, 0.5rem);
  margin-left: var(--spacing-small, 0.1rem);
  padding: 0.188rem; /* 3px */
  background-color: var(--header-menu-item-hover, #e6dcff) !important;
}

.paneHidden {
  width: 24px;
  border-radius: var(--border-radius-md, 0.5rem);
  margin-left: var(--spacing-small, 0.1rem);
  padding: 0.188rem; /* 3px */
}

.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.strongHeader {
  font-size: 150%;
  margin: 0 0.6rem 0 0;
  padding: 0.1rem 0.4rem;
}

.tableFullWidth {
  width: 100%;
  background: var(--color-background, #F8F9FB) !important;
}

.placeholderTable {
  width: 100%;
}

.tdFlex {
  margin: var(--spacing-xxxs, 0.2rem);
  border: none;
  padding: 0;
  vertical-align: top;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}
`, "",{"version":3,"sources":["webpack://./src/outline/manager.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,8CAA8C;EAC9C,yCAAyC;EACzC,iBAAiB,EAAE,QAAQ;EAC3B,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,yCAAyC;EACzC,iBAAiB,EAAE,QAAQ;AAC7B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,uDAAuD;AACzD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":["/* Styles extracted from manager.js */\n\n.obj {\n  margin: 0.2em;\n  border: none;\n  padding: 0;\n  vertical-align: top;\n}\n\n.pred, .pred.internal {\n  /* Add any specific styles for predicate TDs here */\n}\n\n.iconTD {\n  margin: 0.2em;\n  border: none;\n  padding: 0;\n  vertical-align: top;\n  width: 0px;\n}\n\n.labelTD {\n  width: 100%;\n}\n\n.paneIconTray {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.paneShown {\n  width: 24px;\n  border: none !important;\n  border-radius: var(--border-radius-md, 0.5rem);\n  margin-left: var(--spacing-small, 0.1rem);\n  padding: 0.188rem; /* 3px */\n  background-color: var(--header-menu-item-hover, #e6dcff) !important;\n}\n\n.paneHidden {\n  width: 24px;\n  border-radius: var(--border-radius-md, 0.5rem);\n  margin-left: var(--spacing-small, 0.1rem);\n  padding: 0.188rem; /* 3px */\n}\n\n.header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.strongHeader {\n  font-size: 150%;\n  margin: 0 0.6rem 0 0;\n  padding: 0.1rem 0.4rem;\n}\n\n.tableFullWidth {\n  width: 100%;\n  background: var(--color-background, #F8F9FB) !important;\n}\n\n.placeholderTable {\n  width: 100%;\n}\n\n.tdFlex {\n  margin: var(--spacing-xxxs, 0.2rem);\n  border: none;\n  padding: 0;\n  vertical-align: top;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
